import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GuestTextComponentFragment = { __typename?: 'TextComponent'; id: string; text: string; sortOrder: number; type: Types.ComponentType };

export type GuestEventDetailsComponentFragment = { __typename?: 'EventDetailsComponent'; id: string; sortOrder: number; type: Types.ComponentType };

export type GuestRsvpAndUnlockGuestDetailsButtonComponentFragment = {
  __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent';
  id: string;
  sortOrder: number;
  type: Types.ComponentType;
};

export type GuestPhotoComponentFragment = {
  __typename?: 'PhotoComponent';
  id: string;
  type: Types.ComponentType;
  sortOrder: number;
  photo: { __typename?: 'Photo'; id: string; url: string };
};

export type GuestVideoComponentFragment = { __typename?: 'VideoComponent'; id: string; sortOrder: number; type: Types.ComponentType; videoUrl: string; caption?: string | null };

export type GuestTravelMapComponentFragment = { __typename?: 'TravelMapComponent'; id: string; sortOrder: number; blockOrdering?: Array<string> | null; hideExploreCTA: boolean };

export type GuestMediaGalleryComponentFragment = {
  __typename?: 'MediaGalleryComponent';
  id: string;
  sortOrder: number;
  type: Types.ComponentType;
  layout?: string | null;
  mediaCollection?: {
    __typename?: 'MediaCollection';
    id: string;
    name: string;
    magicTokenPermissions?: Array<Types.MagicTokenPermissions | null> | null;
    photoStorageStatus: Types.PhotoAccessStatus;
    isPhotoStorageBlocked: boolean;
    photoUploadStatus: Types.PhotoAccessStatus;
    isPhotoUploadBlocked: boolean;
    photoStorageExpiresAt?: { __typename?: 'Date'; milliseconds: number } | null;
    photoUploadExpiresAt?: { __typename?: 'Date'; milliseconds: number } | null;
    mediaCollectionAttributes: { __typename?: 'MediaCollectionAlbumAttribute'; reactionsEnabled?: boolean | null };
    media?: Array<
      | {
          __typename?: 'MediaPhoto';
          id: string;
          photo: { __typename?: 'Photo'; id: string; url: string; width: number; height: number; deleted: boolean };
          reactions: Array<{ __typename?: 'MediaReactionCount'; id: string; type: Types.MediaReactionType; count: number }>;
        }
      | { __typename?: 'MediaVideo' }
    > | null;
  } | null;
};

export type GuestJsonDataBlobComponentFragment = {
  __typename: 'JsonDataBlobComponent';
  id: string;
  type: Types.ComponentType;
  sortOrder: number;
  jsonDataContainerId: string;
  containerContent: { __typename?: 'JsonDataContainer'; id: string; eventId: string; content: any; type: string; schemaUrl: string };
};

export type GuestPageDataContainerByIdQueryVariables = Types.Exact<{
  payload: Types.JsonDataContainerByIdPayload;
}>;

export type GuestPageDataContainerByIdQuery = {
  __typename?: 'Query';
  jsonDataContainerById?: { __typename?: 'JsonDataContainer'; id: string; eventId: string; content: any; type: string; schemaUrl: string } | null;
};

export type GuestPageContainerBySlugQueryVariables = Types.Exact<{
  payload: Types.PageContainerBySlugPayload;
  isAdminDashboard?: Types.InputMaybe<Types.Scalars['Boolean']>;
  pageKind?: Types.InputMaybe<Types.PageKind>;
}>;

export type GuestPageContainerBySlugQuery = {
  __typename?: 'Query';
  pageContainerBySlug?: {
    __typename?: 'PageContainer';
    id: string;
    slug: string;
    pageKind: Types.PageKind;
    createdAt: { __typename?: 'Date'; timestamp: any };
    components?: Array<
      | { __typename?: 'EventCountdownComponent' }
      | { __typename?: 'EventDetailsComponent'; id: string; sortOrder: number; type: Types.ComponentType }
      | { __typename?: 'EventDisplayNameComponent' }
      | { __typename?: 'GreetingMessageComponent' }
      | {
          __typename: 'JsonDataBlobComponent';
          id: string;
          type: Types.ComponentType;
          sortOrder: number;
          jsonDataContainerId: string;
          containerContent: { __typename?: 'JsonDataContainer'; id: string; eventId: string; content: any; type: string; schemaUrl: string };
        }
      | {
          __typename?: 'MediaGalleryComponent';
          id: string;
          sortOrder: number;
          type: Types.ComponentType;
          layout?: string | null;
          mediaCollection?: {
            __typename?: 'MediaCollection';
            id: string;
            name: string;
            magicTokenPermissions?: Array<Types.MagicTokenPermissions | null> | null;
            photoStorageStatus: Types.PhotoAccessStatus;
            isPhotoStorageBlocked: boolean;
            photoUploadStatus: Types.PhotoAccessStatus;
            isPhotoUploadBlocked: boolean;
            photoStorageExpiresAt?: { __typename?: 'Date'; milliseconds: number } | null;
            photoUploadExpiresAt?: { __typename?: 'Date'; milliseconds: number } | null;
            mediaCollectionAttributes: { __typename?: 'MediaCollectionAlbumAttribute'; reactionsEnabled?: boolean | null };
            media?: Array<
              | {
                  __typename?: 'MediaPhoto';
                  id: string;
                  photo: { __typename?: 'Photo'; id: string; url: string; width: number; height: number; deleted: boolean };
                  reactions: Array<{ __typename?: 'MediaReactionCount'; id: string; type: Types.MediaReactionType; count: number }>;
                }
              | { __typename?: 'MediaVideo' }
            > | null;
          } | null;
        }
      | { __typename?: 'PhotoComponent'; id: string; type: Types.ComponentType; sortOrder: number; photo: { __typename?: 'Photo'; id: string; url: string } }
      | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent'; id: string; sortOrder: number; type: Types.ComponentType }
      | { __typename?: 'TextComponent'; id: string; text: string; sortOrder: number; type: Types.ComponentType }
      | { __typename?: 'TravelMapComponent'; id: string; sortOrder: number; blockOrdering?: Array<string> | null; hideExploreCTA: boolean }
      | { __typename?: 'VideoComponent'; id: string; sortOrder: number; type: Types.ComponentType; videoUrl: string; caption?: string | null }
    > | null;
  } | null;
};

export const GuestTextComponentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestTextComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TextComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GuestEventDetailsComponentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestEventDetailsComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDetailsComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GuestRsvpAndUnlockGuestDetailsButtonComponentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestRsvpAndUnlockGuestDetailsButtonComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RsvpAndUnlockGuestDetailsButtonComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GuestPhotoComponentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestPhotoComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GuestVideoComponentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestVideoComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VideoComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GuestTravelMapComponentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestTravelMapComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelMapComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blockOrdering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideExploreCTA' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GuestMediaGalleryComponentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestMediaGalleryComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaGalleryComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaCollection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'magicTokenPermissions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photoStorageExpiresAt' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'photoStorageStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPhotoStorageBlocked' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photoUploadExpiresAt' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'photoUploadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPhotoUploadBlocked' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mediaCollectionAttributes' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'reactionsEnabled' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reactions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GuestJsonDataBlobComponentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestJsonDataBlobComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JsonDataBlobComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jsonDataContainerId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'containerContent' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'JsonDataContainer' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JsonDataContainer' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JsonDataContainer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaUrl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GuestPageDataContainerByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GuestPageDataContainerById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JsonDataContainerByIdPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jsonDataContainerById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'JsonDataContainer' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JsonDataContainer' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JsonDataContainer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaUrl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGuestPageDataContainerByIdQuery__
 *
 * To run a query within a React component, call `useGuestPageDataContainerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestPageDataContainerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestPageDataContainerByIdQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGuestPageDataContainerByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestPageDataContainerByIdQuery, GuestPageDataContainerByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<GuestPageDataContainerByIdQuery, GuestPageDataContainerByIdQueryVariables>(GuestPageDataContainerByIdDocument, baseOptions);
}
export function useGuestPageDataContainerByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestPageDataContainerByIdQuery, GuestPageDataContainerByIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GuestPageDataContainerByIdQuery, GuestPageDataContainerByIdQueryVariables>(GuestPageDataContainerByIdDocument, baseOptions);
}
export type GuestPageDataContainerByIdQueryHookResult = ReturnType<typeof useGuestPageDataContainerByIdQuery>;
export type GuestPageDataContainerByIdLazyQueryHookResult = ReturnType<typeof useGuestPageDataContainerByIdLazyQuery>;
export type GuestPageDataContainerByIdQueryResult = Apollo.QueryResult<GuestPageDataContainerByIdQuery, GuestPageDataContainerByIdQueryVariables>;
export const GuestPageContainerBySlugDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GuestPageContainerBySlug' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageContainerBySlugPayload' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isAdminDashboard' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageKind' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageKind' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageContainerBySlug' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'admin' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isAdminDashboard' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'pageKind' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'pageKind' } } },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageKind' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdAt' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'components' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestTextComponent' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestTravelMapComponent' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestPhotoComponent' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestVideoComponent' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestMediaGalleryComponent' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestEventDetailsComponent' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestRsvpAndUnlockGuestDetailsButtonComponent' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestJsonDataBlobComponent' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestTextComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TextComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestEventDetailsComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDetailsComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestRsvpAndUnlockGuestDetailsButtonComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RsvpAndUnlockGuestDetailsButtonComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestPhotoComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestVideoComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VideoComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestTravelMapComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelMapComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blockOrdering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideExploreCTA' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestMediaGalleryComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaGalleryComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaCollection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'magicTokenPermissions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photoStorageExpiresAt' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'photoStorageStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPhotoStorageBlocked' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photoUploadExpiresAt' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'photoUploadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPhotoUploadBlocked' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mediaCollectionAttributes' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'reactionsEnabled' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reactions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuestJsonDataBlobComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JsonDataBlobComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jsonDataContainerId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'containerContent' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'JsonDataContainer' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JsonDataContainer' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JsonDataContainer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaUrl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGuestPageContainerBySlugQuery__
 *
 * To run a query within a React component, call `useGuestPageContainerBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestPageContainerBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestPageContainerBySlugQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *      pageKind: // value for 'pageKind'
 *   },
 * });
 */
export function useGuestPageContainerBySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestPageContainerBySlugQuery, GuestPageContainerBySlugQueryVariables>) {
  return ApolloReactHooks.useQuery<GuestPageContainerBySlugQuery, GuestPageContainerBySlugQueryVariables>(GuestPageContainerBySlugDocument, baseOptions);
}
export function useGuestPageContainerBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestPageContainerBySlugQuery, GuestPageContainerBySlugQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GuestPageContainerBySlugQuery, GuestPageContainerBySlugQueryVariables>(GuestPageContainerBySlugDocument, baseOptions);
}
export type GuestPageContainerBySlugQueryHookResult = ReturnType<typeof useGuestPageContainerBySlugQuery>;
export type GuestPageContainerBySlugLazyQueryHookResult = ReturnType<typeof useGuestPageContainerBySlugLazyQuery>;
export type GuestPageContainerBySlugQueryResult = Apollo.QueryResult<GuestPageContainerBySlugQuery, GuestPageContainerBySlugQueryVariables>;
